import React, { useState, useRef } from 'react';
import AuctionCard from '../auction-card/index';
import { Stack, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATH } from '../../../constants/route-constants';
import NoData from '../no-data';
import InfiniteScroll from 'react-infinite-scroller';
import useInitialData from '../../../utils/use-initial-data';
import SkeletonLoader from '../../common/skeleton-loader';
import PropTypes from 'prop-types';
import RefreshIcon from '@mui/icons-material/Refresh';
import { PAGE_SIZE } from '../../../constants/app-constants';

const MyCarsList = ({ getMyCarsConnect }) => {
    const [myCars, setMyCars] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const ref = useRef({ currentPage: 0, pageSize: PAGE_SIZE });
    const navigate = useNavigate();
    const handleCardClick = (auctionId) => {
        navigate(`${ROUTE_PATH.MY_CARS}${ROUTE_PATH.AUCTION_DETAILS}?aid=${auctionId}`);
    };

    const setInitialData = (data, isPaginate) => {
        setMyCars(isPaginate ? [...myCars, ...data?.results] : data?.results);
        setTotalCount(data?.total);
    };

    const makePayload = () => {
        return { page: ref.current.currentPage, size: ref.current.pageSize };
    };

    useInitialData({
        setDataList: setInitialData,
        setLoading,
        fetchData: getMyCarsConnect,
        payload: makePayload()
    });

    const loadMoreData = async () => {
        try {
            if (myCars?.length < totalCount && (ref.current.currentPage + 1) === (myCars?.length / ref.current.pageSize)) {
                setLoading(true);
                ref.current.currentPage += 1;
                const payload = makePayload();
                getMyCarsConnect(payload, true).then(res => {
                    setInitialData(res, true);
                }).finally(() => setLoading(false));
            }
        } catch (error) {
            setLoading(false);
        }
    };

    const handleRefresh = () => {
        setLoading(true);
        ref.current.currentPage = 0;
        getMyCarsConnect(makePayload()).then(res => {
            setInitialData(res);
        }).finally(() => setLoading(false));
    };

    const handleSubTitleClick = () => {
        navigate(`${ROUTE_PATH.EXPLORE}`);
    };
    const isDataAvailable = (myCars && myCars?.length > 0);

    const title = !isDataAvailable ? 'Please bid on any car to view this page.' : `Oops ! You haven't participated in auction yet.`;
    return (
        <React.Fragment>
            <Stack direction={'row'} spacing={2} alignItems="center" justifyContent={'flex-end'} className='mb-2'>
                <Button size='small' onClick={handleRefresh} className='bg-light-border text-text' startIcon={<RefreshIcon />}>
                    Refresh
                </Button>
            </Stack>
            {isDataAvailable &&
                <React.Fragment>
                    <InfiniteScroll
                        pageStart={0}
                        loadMore={loadMoreData}
                        threshold={50}
                        hasMore={!!myCars?.length < totalCount}
                    >
                        <Stack spacing={3} direction={'column'}>
                            {myCars?.map((auction, index) => (
                                <AuctionCard key={index} isSlider={true} auction={auction} handleCardClick={handleCardClick.bind(null, auction?.appointmentId)} />
                            ))}
                        </Stack>
                    </InfiniteScroll>
                </React.Fragment>
            }
            {loading && <SkeletonLoader />}
            {!isDataAvailable && !loading && <NoData handleRefresh={handleRefresh} subTitleClass="text-lg mt-8 text-primary" title={title} subTitle={'View live auctions running.'} handleSubTitleClick={handleSubTitleClick} />}
        </React.Fragment>
    );
};

MyCarsList.propTypes = {
    getMyCarsConnect: PropTypes.func
};

export default MyCarsList;
